export const ROUTE_MENU = "ROUTE_MENU";
export const NEWS_MENU = "NEWS_MENU";